import { memo } from 'react';

function TrailerBackFill(props) {
  const { color = '#666666', size = 14 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.65286 0.421143C1.29105 0.421143 0.185791 1.52638 0.185791 2.8882C0.185791 4.25003 1.29105 5.35527 2.65286 5.35527C4.01471 5.35527 5.11994 4.25003 5.11994 2.8882C5.11994 1.52638 4.01471 0.421143 2.65286 0.421143ZM3.88638 3.13493H1.41931V2.64151H3.88638V3.13493Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53201 3.03081C5.53201 3.08081 5.53073 3.13048 5.52817 3.17982H9.01987V8.51733H4.91354C4.61203 8.2637 4.22287 8.11092 3.79801 8.11092C3.37317 8.11092 2.98401 8.2637 2.68247 8.51733H1.94837V5.74326C1.54257 5.62891 1.17395 5.42593 0.864624 5.15659V9.60107H2.08103C2.06979 9.68076 2.064 9.76216 2.064 9.84492C2.064 10.8026 2.84036 11.5789 3.79801 11.5789C4.75568 11.5789 5.53201 10.8026 5.53201 9.84492C5.53201 9.76216 5.52622 9.68076 5.51502 9.60107H11.8376V8.51733H10.1036V2.09607H5.37329C5.47611 2.38858 5.53201 2.70316 5.53201 3.03081ZM4.39737 9.60107C4.30109 9.36469 4.069 9.19806 3.79801 9.19806C3.52704 9.19806 3.29495 9.36469 3.19867 9.60107C3.168 9.67636 3.15109 9.75868 3.15109 9.84496C3.15109 10.2022 3.44077 10.4918 3.79801 10.4918C4.15527 10.4918 4.44492 10.2022 4.44492 9.84496C4.44492 9.75868 4.42804 9.67636 4.39737 9.60107Z"
        fill={color}
      />
    </svg>
  );
}
export default memo(TrailerBackFill);
